import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type {
  BaseConnectionData,
  GoogleWorkspaceConfigData,
} from './EnterpriseConnectionSchema';
import {
  ClientCredentialsFields,
  DomainField,
  LoginExperienceSection,
} from './SharedSsoFormFields';

interface Props {
  isDisabled?: boolean;
}

const GoogleWorkspaceConfigurationForm: FC<Props> = ({
  isDisabled = false,
}) => {
  const { control } = useFormContext<GoogleWorkspaceConfigData>();
  const baseControl = control as unknown as Control<BaseConnectionData>;
  const { t } = useTranslation('common', { keyPrefix: 'sso' });

  return (
    <>
      <DomainField
        control={baseControl}
        isDisabled={isDisabled}
        label={t('domain.google.label')}
        description={t('domain.google.description')}
        placeholder={t('domain.google.placeholder')}
      />

      <ClientCredentialsFields
        control={baseControl}
        isDisabled={isDisabled}
        providerLabel={'Google Workspace'}
      />

      <LoginExperienceSection control={baseControl} isDisabled={isDisabled} />
    </>
  );
};

export default GoogleWorkspaceConfigurationForm;
